module.exports = __webpack_public_path__ + "img/logo.44bd4036.png";